import { useEffect } from "react";
import "@/assets/styles/Captcha.css";

export default function Captcha({ fetchCaptcha, value, setValue, imgSrc, loading }) {
    useEffect(() => {
        fetchCaptcha();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRefresh = () => {
        setValue("");
        fetchCaptcha();
    };

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    return (
        <div className="captcha-container">
            <div className="canvas-container">
                {imgSrc ? (
                    <img src={imgSrc} alt="captcha" />
                ) : (
                    <div style={{ height: 44, display: "flex", alignItems: "center", padding: "0 12px" }}>
                        {loading ? "در حال بارگذاری..." : "خطا در دریافت تصویر"}
                    </div>
                )}

                <button id="reload-button" type="button" onClick={handleRefresh} disabled={loading}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                        <path d="M3 3v5h5" />
                        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                        <path d="M16 16h5v5" />
                    </svg>
                </button>
            </div>

            <input
                id="user-input"
                placeholder="کد تصویر را وارد کنید"
                value={value}
                onChange={handleChange}
                autoComplete="off"
                required
            />
        </div>
    );
}
